/**
 * Component is used to show order summary promotions on the order confirmation page
 *
 * @param {Array}  [appliedPromotions] - Applied promotions for current order
 *
 * HTML Structure Example
 * <e2-order-summary-promotions></e2-order-summary-promotions>
 *
 */

import connect from '@elab/core/store/connect';
import { selectors } from '@elab/core/store/order';

import { CartSummaryPromotions } from '../cart/CartSummaryPromotions';

const mapStateToProps = state => {
    const order = selectors.getOrderData(state);

    return {
        appliedPromotions: order.appliedPromotions || [],
        isOrderSummary: true,
    };
};

export default () =>
    customElements.define(
        'e2-order-summary-promotions',
        connect(mapStateToProps)(CartSummaryPromotions),
    );
